import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { FormattedMessage } from 'react-intl';
import {
  faFileCheck,
} from '@fortawesome/pro-solid-svg-icons';
import { faAward, faRocket, faLock, faShield } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import 'Features/Bundle/components/BundleRedesign/BundleRedesignBookPoints.scss';

const BundleRedesignBookPoints = ({ mixedBundle, downloadTypes, slug, drm }) => {
  let showFileTypes = true;
  if (slug === 'deathlands-sci-fi-novels-bundle' || slug === 'rogue-angel-fantasy-novels-bundle') {
    showFileTypes = false;
  }
  if (drm[0] === 'idw' || drm[0] === 'drivethrurpg') {
    showFileTypes = false;
  }

  return (
    <div className="BundleRedesignBookPoints">
      <article className="BundleRedesignBookPoints__point">
        <div className="BundleRedesignBookPoints__point__icon">
          <FontAwesomeIcon icon={faAward} />
        </div>
        <div className="BundleRedesignBookPoints__point__textContainer">
          <div className="BundleRedesignBookPoints__point__text">
            <FormattedMessage id="bundleredesignbookpoints.trustheader" defaultMessage="Lifetime Ownership" />
          </div>
          <div className="BundleRedesignBookPoints__point__subtext text-muted">
            {!mixedBundle &&
              <FormattedMessage id="bundleredesignbookpoints.trusttext" defaultMessage="Download and keep your eBooks forever." />
            }
            {mixedBundle &&
              <FormattedMessage id="bundleredesignbookpoints.trusttext.mixed" defaultMessage="Download and keep your products forever." />
            }
          </div>
        </div>
      </article>

      <article className="BundleRedesignBookPoints__point">
        <div className="BundleRedesignBookPoints__point__icon">
          <FontAwesomeIcon icon={faRocket} />
        </div>
        <div className="BundleRedesignBookPoints__point__textContainer">
          <div className="BundleRedesignBookPoints__point__text">
            <FormattedMessage id="bundleredesignbookpoints.trustheadertwo" defaultMessage="Instant Delivery" />
          </div>
          <div className="BundleRedesignBookPoints__point__subtext text-muted">
            {!mixedBundle &&
              <FormattedMessage id="bundleredesignbookpoints.trusttexttwo" defaultMessage="Your eBooks are available to read in minutes." />
            }
            {mixedBundle &&
              <FormattedMessage id="bundleredesignbookpoints.trusttexttwo.mixed" defaultMessage="Your products are available in minutes." />
            }
          </div>
        </div>
      </article>

      {showFileTypes &&
        <article className="BundleRedesignBookPoints__point">
          <div className="BundleRedesignBookPoints__point__icon">
            <FontAwesomeIcon icon={faFileCheck} />
          </div>
          {downloadTypes && downloadTypes.length === 1 &&
            <div className="BundleRedesignBookPoints__point__textContainer">
              <div className="BundleRedesignBookPoints__point__text">
                <FormattedMessage
                  id="bundleredesignbookpoints.trustheaderthree.single"
                  defaultMessage="{fileType} file types"
                  values={{
                    fileType: downloadTypes[0],
                  }}
                />
              </div>
              <div className="BundleRedesignBookPoints__point__subtext text-muted">
                <FormattedMessage
                  id="bundleredesignbookpoints.trusttextthree.single"
                  defaultMessage="All your eBooks are provided as {fileType}."
                  values={{
                    fileType: <span className="text-uppercase">{downloadTypes[0]}</span>,
                  }}
                />
              </div>
            </div>
          }
          {(isEmpty(downloadTypes) || downloadTypes.length > 1) &&
            <div className="BundleRedesignBookPoints__point__textContainer">
              <div className="BundleRedesignBookPoints__point__text">
                <FormattedMessage id="bundleredesignbookpoints.trustheaderthree" defaultMessage="Multiple file types" />
              </div>
              <div className="BundleRedesignBookPoints__point__subtext text-muted">
                {!mixedBundle &&
                  <FormattedMessage id="bundleredesignbookpoints.trusttextthree" defaultMessage="Choose how you want to read your eBooks." />
                }
                {mixedBundle &&
                  <FormattedMessage id="bundleredesignbookpoints.trusttextthree.mixed" defaultMessage="Choose how you want to view your files." />
                }
              </div>
            </div>
          }
        </article>
      }
      {(isEmpty(drm) || drm[0] === 'drm_free') &&
        <article className="BundleRedesignBookPoints__point">
          <div className="BundleRedesignBookPoints__point__icon">
            <FontAwesomeIcon icon={faLock} />
          </div>
          <div className="BundleRedesignBookPoints__point__textContainer">
            <div className="BundleRedesignBookPoints__point__text">
              <FormattedMessage id="bundleredesignbookpoints.trustheaderfour" defaultMessage="DRM Free" />
            </div>
            <div className="BundleRedesignBookPoints__point__subtext text-muted">
              <FormattedMessage id="bundleredesignbookpoints.trusttextfour" defaultMessage="All eBooks are DRM free." />
            </div>
          </div>
        </article>
      }
      {drm[0] === 'idw' &&
        <article className="BundleRedesignBookPoints__point">
          <div className="BundleRedesignBookPoints__point__icon">
            <FontAwesomeIcon icon={faShield} />
          </div>
          <div className="BundleRedesignBookPoints__point__textContainer">
            <div className="BundleRedesignBookPoints__point__text">
              <FormattedMessage id="bundleredesignbookpoints.trustheaderidw" defaultMessage="Easy Redemption" />
            </div>
            <div className="BundleRedesignBookPoints__point__subtext text-muted">
              <FormattedMessage id="bundleredesignbookpoints.trusttextidw" defaultMessage="Redeem on the free IDW app." />
            </div>
          </div>
        </article>
      }
      {drm[0] === 'drivethrurpg' &&
        <article className="BundleRedesignBookPoints__point">
          <div className="BundleRedesignBookPoints__point__icon">
            <FontAwesomeIcon icon={faShield} />
          </div>
          <div className="BundleRedesignBookPoints__point__textContainer">
            <div className="BundleRedesignBookPoints__point__text">
              <FormattedMessage id="bundleredesignbookpoints.trustheaderdrivethrurpg" defaultMessage="Easy Redemption" />
            </div>
            <div className="BundleRedesignBookPoints__point__subtext text-muted">
              <FormattedMessage id="bundleredesignbookpoints.trusttextdrivethrurpg" defaultMessage="Redeem through DriveThruRPG." />
            </div>
          </div>
        </article>
      }
    </div>
  );
};

export default BundleRedesignBookPoints;
